import React from "react";

import { ActivityList } from "app/userManagement/modules/generic/index";

const OperatorActivityList = () => {
  return (
    <>
      <ActivityList />
    </>
  );
};

export default OperatorActivityList;
